export default "__VITE_ASSET__RC$KHhgl__"